(ns common.resource.query.adserver
  (:require [common.flags :refer [use-flag]]
            [common.queries :refer [use-query]]
            [common.queries.http :as qhttp]
            [uix.core :refer [defhook]]))

(defn adservers-query []
  #js {:queryKey #js ["adservers"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/adservers {})))})

(defn rename-adserver-to-new-name [name]
  (-> name
      ({"AppNexus" "Xandr"
        "DoubleClick Campaign Manager" "Google CM360"} name)))

(defn adserver-type-from-id [current-adserver]
  (case current-adserver
    1 :app-nexus
    2 :trade-desk
    3 :dcm
    4 :adform
    5 :trade-desk ; manage-test
    8 :dcm ; manage-test
    11 :adform ; manage-test
    nil))

(defn xandr-adserver? [adserver-id]
  (= :app-nexus (adserver-type-from-id adserver-id)))

(defhook use-adservers-options []
  (let [xandr-enabled? (use-flag :xandr-adserver-support)
        {adservers :data} (use-query (adservers-query))]
    (cond->> adservers
      true (mapv (fn [{:keys [id name]}]
                   {:value id
                    :label (rename-adserver-to-new-name name)}))
      (not xandr-enabled?) (remove #(xandr-adserver? (:value %))))))
